
import React, { useState, useEffect } from "react";
import { AddProfile } from "./components/AddProfile";
import { EditProfile } from "./components/EditProfile";
import { Delete } from "./components/Delete";
import { Leave } from "./components/Leave";
import { useSelector, useDispatch } from 'react-redux';
import {
    getCountriesDataThunk,
    fetchProfilesThunk,
    createProfileThunk,
    updateProfileThunk,
    deleteProfileThunk,
    updateSelectedProfile
} from '../../../redux/features/userSlice';
import { FLAG } from '../../../config';
import * as amplitude from '@amplitude/analytics-browser';

export const Avatar = ({
    handleAvatar,
    handleSubscription,
    subscription,
    setIsChanged
}) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user)

    const [state, setState] = useState("add");
    const countries = useSelector((state) => state.user.countries);
    const profiles = useSelector((state) => state.user.profiles);
    const [selectedAvatars, setSelectedAvatars] = useState([]);
    useEffect(() => {
        setSelectedAvatars((profiles || []).filter(p => p.avatar !== "null"));
    }, [profiles]);
    const selectedProfile = useSelector((state) => state.user.selectedProfile)
    const [country, setCountry] = useState(useSelector((state) => state.user?.selectedProfile?.cc) || "");

    const [index, setIndex] = useState('');
    const [openCountry, setOpenCountry] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openLeave, setOpenLeave] = useState(false);

    const num = index || 0
    const deviceToken = user?.user?.userEmail
    const [countryObj, setCountryObj] = useState(null);

    const lang = localStorage.getItem('i18nextLng') || 'en'
    const regionNames = new Intl.DisplayNames([lang], { type: 'region' });
    const regionNamesEn = new Intl.DisplayNames(['en'], { type: 'region' });
    const countryLabel =
        typeof country === "string" && country.length === 2
            ? regionNames.of(country)
            : "";

    const handleSave = async (avatar, nickName) => {
        let age = 10;

        if (!selectedAvatars[num]) {
            await dispatch(
                createProfileThunk({ deviceToken, avatar, nickName, age })
            );
        } else {
            await dispatch(
                updateProfileThunk({
                    _id: selectedProfile._id,
                    avatar,
                    nickName,
                    age
                })
            );
        }

        await dispatch(fetchProfilesThunk(deviceToken));

        setState("add");
        setIndex("");
    };


    useEffect(() => {
        amplitude.track("profile_list_open",{
            count:profiles.length
        });
    }, []);


    const confirmDelete = async () => {
        const profileId = selectedProfile._id;

        await dispatch(deleteProfileThunk({ profileId, deviceToken }))

        amplitude.track("profile_edit_delete");
        setOpenDelete(false);
        setState("add");
        setIndex('');
    };

    const confirmLeave = () => {
        setIsChanged(false)
        setOpenLeave(false);
        setState("add");
        setIndex('');
    };



    const handleCountry = async (flag) => {
        setCountry(flag.split(".")[0]);
        setOpenCountry(false);

        if (selectedProfile) {
            await dispatch(
                updateProfileThunk({
                    _id: selectedProfile._id,
                    cc: flag.split(".")[0]
                })
            );
        }
    }

    const handleState = (i) => {
        if (typeof (i) === "object") {
            setState("add");
            setIndex('');
        } else if(i === true) {
            setOpenLeave(true);
        } else {
            setState("edit");
            setIndex(i);
        }
    }

    useEffect(() => {
        if (!profiles.length) {
            dispatch(updateSelectedProfile(null));
            localStorage.removeItem('profile');
            return;
        }

        const stored = localStorage.getItem('profile');
        const storedProfile = stored ? JSON.parse(stored) : null;

        const exists = profiles.find(p => p._id === storedProfile?._id);

        if (exists) {
            dispatch(updateSelectedProfile(exists));
        } else {
            dispatch(updateSelectedProfile(profiles[0]));
            localStorage.setItem('profile', JSON.stringify(profiles[0]));
        }
    }, [profiles, dispatch]);

    ////
    useEffect(() => {
        if (deviceToken) {
            dispatch(fetchProfilesThunk(deviceToken));
        }
    }, [dispatch, deviceToken]);
    ////

    useEffect(() => {
        dispatch(getCountriesDataThunk());
    }, [dispatch]);



    useEffect(() => {
        if (user?.selectedProfile?.cc) {
            setCountry(user.selectedProfile.cc);
        }
    }, [user.selectedProfile?.cc]);


    useEffect(() => {
        if (!countries.length) return;
        if (!country || country.length !== 2) return;

        const countryNameEn = regionNamesEn.of(country);

        const found = countries.find(
            item =>
                item.country?.toLowerCase() === countryNameEn?.toLowerCase()
        );

        setCountryObj(found || null);
    }, [countries, country]);


    return (
        <div onClick={() => handleAvatar()} className="bg-bgBlack/49 h-screen flex justify-center items-center w-full absolute z-[70]">
            <div onClick={(e) => e.stopPropagation()} className="relative flex justify-center items-center sm:w-[640px] sm:h-[302px] md:w-[652px] md:h-[428px] lg:w-[928px] lg:h-[452px] lg:rounded-[16px] rounded-[13px] xl:rounded-[30px] xl:w-[1142px] xl:h-[576px] shadow-[0px_6px_36px_0px_rgba(109, 109, 109, 0.25)] sm:bg-[url('/backGrounds/secondarybackground.svg')] bg-[url('/backGrounds/newbackgroundMobile.svg')] bg-cover w-[360px] xs:w-[440px] h-[288px] xs:h-[364px] ">
                {openDelete && <Delete handleDelete={() => setOpenDelete(!openDelete)} confirmDelete={confirmDelete} />}
                {openLeave && <Leave handleLeave={() => setOpenLeave(!openLeave)} confirmLeave={confirmLeave} setIsChanged={setIsChanged}/>}

                {(state === "add" && !country && selectedProfile) && <img
                    onClick={() => setOpenCountry(!openCountry)}
                    className="cursor-pointer absolute w-[30px] h-[30px] top-[18px] right-[18px] md:w-[39px] md:h-[39px] md:right-[20px] md:top-[20px] lg:w-[46px] lg:h-[46px] xl:right-[32px] xl:top-[32px]"
                    src="/backGrounds/profile/country.svg"
                />}
                {
                    state === "add" && country &&   <div
                        onClick={() => setOpenCountry(!openCountry)}
                        className="cursor-pointer text-[14px] flex items-center justify-center rounded-[10px] top-[18px] right-[18px] min-w-[101px] px-[10px] h-[34px] absolute md:min-w-[111px] md:h-[39px] md:text-[16px]  md:right-[20px] md:top-[20px] lg:right-[32px] lg:text-[20px] lg:top-[32px] font-fredokaOne lg:min-w-[146px] lg:h-[46px] md:rounded-[13px] text-[#fff] bg-[#905ED0]"
                    >
                        <div
                            className="bg-cover bg-no-repeat bg-[position:50%_50%] min-w-[20px] h-[20px] md:min-w-[24px] md:h-[24px] lg:min-w-[26px] lg:h-[26px] rounded-[50%]"
                            style={{ backgroundImage: countryObj ? `url(${FLAG}${countryObj.flag})` : 'none' }}
                        />

                        <p className="ml-[7px] lg:ml-[10px]">{countryLabel}</p>
                    </div>
                }
                {
                    state === "add" && openCountry && <div
                        className="z-[15] lang overflow-y-scroll p-[12px] text-[14px] md:p-[14px] md:text-[16px] lg:p-[16px] lg:text-[20px] text-[#2F9EBA] font-fredokaOne  w-[160px] h-[164px] rounded-[13px] absolute right-[16px] top-[64px] md:w-[166px] md:h-[204px] md:right-[20px] md:top-[68px] lg:w-[218px] lg:h-[226px] lg:top-[87px] xl:h-[310px] xl:top-[87px] xl:right-[32px] bg-[#FFFBED] shadow-[0px_6px_36px_0px_#DCDCDD]">
                        {
                            countries.map((item) => <div key={item.country} onClick={() => handleCountry(item.flag)} className="flex items-center h-[20px] md:h-[24px] lg:h-[26px] lg:mb-[16px] mb-[10px] md:mb-[14px] cursor-pointer">

                                <div
                                    className="bg-cover bg-no-repeat bg-[position:50%_50%] min-w-[20px] h-[20px] md:min-w-[24px] md:h-[24px] lg:min-w-[26px] lg:h-[26px] rounded-[50%]"
                                    style={{ backgroundImage: `url(${FLAG}${item.flag})` }}
                                />


                                <p title={item.country} className="ml-[7px] lg:ml-[12px] truncate">{item.country}</p>
                            </div>)
                        }
                    </div>
                }
                {state === "add" && <AddProfile
                    subscription={subscription}
                    selectedProfile={selectedProfile}
                    selectedAvatars={selectedAvatars.length < 3 && selectedAvatars[selectedAvatars.length - 1] ? [...selectedAvatars, null] : selectedAvatars.length ? selectedAvatars : [null]}
                    handleState={handleState}
                    handleSubscription={handleSubscription}
                />}
                {state === "edit" && <EditProfile
                    user={user}
                    handleSave={handleSave}
                    handleState={handleState}
                    handleDelete={() => setOpenDelete(!openDelete)}
                    handleLeave={() => setOpenLeave(!openLeave)}
                    profile={selectedAvatars[num]}
                    handleAvatar={handleAvatar}
                    setIsChanged={setIsChanged}
                />}
            </div>
        </div>
    )
}